(()=>{
 const root=window.Shopify?.routes?.root||'/';
 const read=async response=>{
  if(!/json|javascript/.test(response.headers.get('content-type')||''))throw Error('Sepet bağlantısı kurulamadı. Lütfen tekrar deneyin.');
  const data=await response.json();
  if(!response.ok)throw Error(data.description||data.message||'Sepet güncellenemedi.');
  return data;
 };
 const request=(endpoint,data)=>window.deFetch(root+endpoint,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(data)}).then(read);
 window.deAddProducts=async(items,sections={})=>{
  const merged=new Map();
  for(const item of items)merged.set(String(item.id),(merged.get(String(item.id))||0)+item.quantity);
  const codes=[...new Set(items.map(item=>item.offerCode).filter(Boolean))];
  let previous=[];
  if(codes.length){const cart=await window.deFetch(root+'cart.js',{headers:{Accept:'application/json'}}).then(read);previous=(cart.discount_codes||[]).filter(d=>d.applicable).map(d=>d.code)}
  const added=await request('cart/add.js',{items:[...merged].map(([id,quantity])=>({id,quantity})),...sections});
  if(!codes.length)return added;
  try{
   const cart=await request('cart/update.js',{discount:[...new Set([...previous,...codes])].join(','),...sections});
   const applied=new Set((cart.discount_codes||[]).filter(d=>d.applicable).map(d=>d.code.toUpperCase()));
   if(codes.some(code=>!applied.has(code.toUpperCase())))throw Error('İndirim uygulanamadı.');
   return cart;
  }catch(error){
   sessionStorage.setItem('de-offer-notice','Ürünler sepete eklendi; ek ürün indirimi doğrulanamadı. Ödemeden önce toplamı kontrol edin.');
   error.cartChanged=true;throw error;
  }
 };
 const notice=sessionStorage.getItem('de-offer-notice');
 // Send selected extras through Shopify's cart before opening the COD form.
 document.addEventListener('click',event=>{
  const cod=event.target.closest('.es-popup-button');
  const section=cod?.closest('[data-de-product]');
  if(!section||!section.querySelector('[data-extra-check]:checked'))return;
  event.preventDefault();event.stopImmediatePropagation();
  const form=section.querySelector('.de-product-form');
  form.dataset.deAfterAdd='cod';form.requestSubmit(form.querySelector('.de-add'));
 },true);
 if(document.querySelector('[data-de-cart]')&&new URLSearchParams(location.search).get('odeme')==='kapida'){
  let observer,timer,opened=false;
  const open=()=>{
   const button=document.querySelector('[data-de-cart] .de-cart-summary .es-popup-button-cart');
   if(opened||!button||button.disabled||!button.getClientRects().length)return;
   opened=true;observer?.disconnect();clearTimeout(timer);
   const url=new URL(location.href);url.searchParams.delete('odeme');history.replaceState({},'',url);
   button.click();
  };
  observer=new MutationObserver(open);observer.observe(document.body,{childList:true,subtree:true});
  timer=setTimeout(()=>observer.disconnect(),15000);open();
 }
 if(notice&&document.querySelector('[data-de-cart]')){
  const target=document.querySelector('.de-cart-error');
  if(target){target.textContent=notice;target.hidden=false;sessionStorage.removeItem('de-offer-notice')}
 }
})();
